/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useCallback, useEffect, useMemo, useRef, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";

import DataTable from "examples/Tables/DataTable";
import {
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  Menu,
  MenuItem,
  Switch,
} from "@mui/material";
import applicator from "ajv/dist/vocabularies/applicator";
import colors from "assets/theme/base/colors";
import { useNavigate } from "react-router-dom";
import NotificationItem from "examples/Items/NotificationItem";
import moment from "moment";
import debounce from "lodash.debounce";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { exportToExcel } from "utilities";
import { NumberFormatter } from "utilities";
import { fairStatus } from "utilities";
import { statusColors } from "utilities";
import AddLocation from "layouts/location/add-location";
import { notify } from "utilities";
import { getAllLocation } from "api";
import { deleteLocation } from "api";

// import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";

export default function data({ fair, isForDashboard = false }) {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);

  const [menuAnchor, setMenuAnchor] = useState(null);
  const [currentRowId, setCurrentRowId] = useState(null);

  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState();
  const [loadingId, setLoadingId] = useState(null);

  const [openConfirm, setOpenConfirm] = useState(false);

  const [showAdd, setShowAdd] = useState(false);
  const [locationData, setLocationData] = useState();

  const lastSearch = useRef("");
  const isFetching = useRef(false);
  const lastApiParams = useRef("");
  const resizeTimeout = useRef(null);
  const didMount = useRef(false);
  const isFirstLoad = useRef(true);

  useEffect(() => {
    const handleResize = () => {
      clearTimeout(resizeTimeout.current);
      resizeTimeout.current = setTimeout(() => {
        // do nothing → just absorb resize re-renders
      }, 300);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (didMount.current) return;

    didMount.current = true;

    getAllLocationApi();
  }, []);

  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }

    getAllLocationApi();
  }, [search]);

  const debouncedFetch = useMemo(
    () =>
      debounce((searchVal) => {
        setSearch(searchVal);
      }, 500),
    []
  );

  useEffect(() => {
    return () => {
      debouncedFetch.cancel();
    };
  }, [debouncedFetch]);

  useEffect(() => {
    getAllLocationApi();
  }, [page]);

  const getAllLocationApi = (isReset = false) => {
    var params = {
      page: page,
      limit: limit,
      name: search,
      fair: fair?._id,
    };

    if (isReset) {
      // params.type = "all";
      // params.industry = "all";
      // params.location = "all";
      // params.sponsor = "all";
    } else {
      // params.type = status?.key || "all";
      // params.industry = industry?._id || "all";
      // params.location = location?.name || "all";
      // params.sponsor = sponsor?._id || "all";
    }

    const key = JSON.stringify(params);
    // 🚀 BLOCK if same API already called
    if (lastApiParams.current === key) return;

    lastApiParams.current = key;

    if (isFetching.current) return; // 🚀 BLOCK duplicate calls
    isFetching.current = true;

    setLoading(true);

    getAllLocation({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            setList(responseJson?.location || []);
            setTotal(responseJson?.total || 0);
          }
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoading(false);
        isFetching.current = false;
      });
  };

  const onSearchData = (val) => {
    if (lastSearch.current === val) return; // 🚀 STOP duplicate
    lastSearch.current = val;
    setPage(1);
    debouncedFetch(val);
  };

  const handleAction = (event, rowId) => {
    setMenuAnchor(event.currentTarget);
    setCurrentRowId(rowId);
  };

  const closeMenu = () => {
    setMenuAnchor(null);
  };

  const onPressAdd = () => {
    setCurrentRowId(null);
    setLocationData();
    setShowAdd(true);
  };

  const onSubmitAddLocation = () => {
    setShowAdd(false);
    getAllLocationApi();
  };

  const columns = useMemo(() => {
    const baseColumns = [
      { Header: "name", accessor: "name", align: "left" },
      { Header: "main entry", accessor: "mainEntry", align: "center" },
      // { Header: "user assigned", accessor: "userAssigned", align: "center" },
      {
        Header: "checked-in",
        accessor: "checkedIn",
        align: "center",
      },
      // {
      //   Header: "actions",
      //   accessor: "actions",
      //   align: "center",
      // },
    ];

    if (!isForDashboard) {
      baseColumns.splice(2, 0, {
        Header: "user assigned",
        accessor: "userAssigned",
        align: "center",
      });
      baseColumns.splice(4, 0, {
        Header: "actions",
        accessor: "actions",
        align: "center",
      });
    }

    return baseColumns;
  }, []);

  const handleStatus = (item) => {
    setLoadingId(item?._id);
    var params = {
      isActive: item?.isActive ? false : true,
    };
    updateLocationApi(params, item._id);

    // const updatedUsers = list.map((u) => (u._id === user.id ? { ...u, isActive: !u.isActive } : u));
    // setList(updatedUsers);
  };

  //   const handleJobs = useCallback(
  //     (item) => {
  //       navigate("/jobs/all-jobs", { state: { company: item } });
  //     },
  //     [navigate]
  //   );

  //   const handleContacts = useCallback(
  //     (item) => {
  //       navigate("/company/all-contacts", { state: { company: item } });
  //     },
  //     [navigate]
  //   );

  const confirmDialog = () => {
    return (
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this location? This action cannot be undone.
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)} color="error" variant="contained">
            Cancel
          </Button>
          <MDButton onClick={handleDelete} color="error">
            Delete
          </MDButton>
        </DialogActions>
      </Dialog>
    );
  };

  const handleDelete = () => {
    setOpenConfirm(false);

    deleteLocationApi();
  };

  const deleteLocationApi = () => {
    var params = {};

    deleteLocation({
      params: params,
      id: currentRowId,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            notify();
            getAllLocationApi();
          }
        }
      })
      .catch((e) => {});
  };

  const oneEditClick = () => {
    closeMenu();
    setLocationData(list.find((item) => item._id === currentRowId));
    setShowAdd(true);
  };
  const onDeleteClick = () => {
    // Implement delete functionality here
    closeMenu();
    setOpenConfirm(true);
  };

  const renderActionMenu = (rowId) => (
    <Menu
      id={`simple-menu-${rowId}`}
      anchorEl={menuAnchor}
      anchorReference={null}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      open={Boolean(menuAnchor) && currentRowId === rowId}
      onClose={closeMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem icon={<Icon>mode_edit</Icon>} title="Edit" onClick={oneEditClick} />
      <NotificationItem
        icon={<Icon>delete</Icon>}
        title={
          <>
            <span style={{ color: "red" }}>Delete</span>
          </>
        }
        onClick={onDeleteClick}
      />
    </Menu>
  );

  const handleUser = (item) => {
    navigate("/user", { state: { fair: fair, locationData: item } });
  };

  const handleCheckIn = (item) => {
    navigate("/checkin", { state: { fair: fair, locationData: item } });
  };

  const rows = useMemo(() => {
    var rowsData = [];

    list.map((item) =>
      rowsData.push({
        name: (
          <MDBox>
            <MDTypography
              display="block"
              variant="button"
              fontWeight="medium"
              noWrap
              sx={{
                maxWidth: "350px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {item?.name}
            </MDTypography>
          </MDBox>
        ),
        mainEntry: (
          <MDBox sx={{ px: 1 }}>
            <MDTypography
              display="block"
              variant="caption"
              fontWeight="medium"
              noWrap
              color={item?.isMainEntry ? "info" : "secondary"}
            >
              {item?.isMainEntry ? "Yes" : "No"}
            </MDTypography>
          </MDBox>
        ),
        userAssigned: (
          <MDBox
            display="flex"
            gap={0.5}
            color="secondary"
            sx={{ px: 1, cursor: "pointer" }}
            onClick={() => handleUser(item)}
          >
            <MDBadge
              badgeContent={NumberFormatter(parseInt(item?.userCount || 0))}
              color={"light"}
              variant="gradient"
              size="sm"
              circular
            />
            <Icon fontSize="small">people_alt</Icon>
          </MDBox>
        ),
        checkedIn: (
          <MDBox
            display="flex"
            gap={0.5}
            color="secondary"
            sx={{ px: 1, cursor: "pointer" }}
            onClick={() => handleCheckIn(item)}
          >
            <MDBadge
              badgeContent={NumberFormatter(parseInt(item?.checkInCount || 0))}
              color={"light"}
              variant="gradient"
              size="sm"
              circular
            />
            <Icon fontSize="small">people_alt</Icon>
          </MDBox>
        ),
        actions: (
          <MDBox sx={{ px: 1 }} onClick={(e) => handleAction(e, item?._id)}>
            <MDTypography
              component="a"
              variant="caption"
              color="secondary"
              fontWeight="medium"
              sx={{ cursor: "pointer" }}
            >
              <Icon fontSize="small">more_vert</Icon>
            </MDTypography>
          </MDBox>
        ),
      })
    );

    return rowsData;
  }, [list]);

  return (
    <MDBox>
      <Card>
        <MDBox p={3} sx={{ width: "100%", overflowX: "auto" }}>
          {isForDashboard && (
            <MDBox mb={2}>
              <MDTypography display="block" variant="subtitle2" fontWeight="bold" noWrap>
                {"Location-wise Check-ins"}
              </MDTypography>
            </MDBox>
          )}
          <DataTable
            table={{ columns, rows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={true}
            canSearch={isForDashboard ? false : true}
            onSearch={onSearchData}
            page={page}
            limit={limit}
            total={total}
            onPageChange={(newPage) => setPage(newPage)}
            // canAdd={{
            //   onClick: onPressAdd,
            //   label: "Add",
            // }}
            canAdd={
              !isForDashboard
                ? {
                    onClick: onPressAdd,
                    label: "Add",
                  }
                : undefined
            }
          />
          {list.map((item) => renderActionMenu(item?._id))}

          {/* {confirmDialogAdd()} */}

          {confirmDialog()}

          {showAdd && (
            <AddLocation
              visible={showAdd}
              fairData={fair}
              locationData={locationData}
              onClose={() => {
                setShowAdd(false);
              }}
              onSubmit={onSubmitAddLocation}
            ></AddLocation>
          )}

          {loading && (
            <MDBox display="flex" justifyContent="center" mt={2}>
              <CircularProgress size={24} color="info" />
            </MDBox>
          )}
        </MDBox>
      </Card>
    </MDBox>
  );
}
